import { createSlice } from "@reduxjs/toolkit";
import { fetchCustomers } from "./customersDuck";
import uiReducer, { uiDefaultState } from "../../src/Dashboard/ducks/uiDuck";
import settingsUIReducer, { settingsUIDefaultState } from "../../src/Dashboard/ducks/settingsUIDuck";
import graphicsReducer, { graphicsDefaultState } from "../../src/Dashboard/ducks/graphicsDuck";

const UI_CROSS_TIER = new Set([
  "system/fetchEventUpdateSocket",
  "devices/fetchEdgeDataSocket/fulfilled",
  "reports/fetchReports/fulfilled",
  "reports/fetchReports/rejected",
  "settings/fetchSettingsAuth/fulfilled",
]);

const isUIAction = (action) => {
  const systemId = action.payload?.systemId || action.meta?.arg?.systemId;
  if (!systemId) return false;
  const t = action.type;
  return (
    t.startsWith("ui/") ||
    t.startsWith("settingsUI/") ||
    t.startsWith("graphics/") ||
    UI_CROSS_TIER.has(t)
  );
};

const uiTierSlice = createSlice({
  name: "ui",
  initialState: {},
  reducers: {
    initializeDeviceUI(state, action) {
      const { systemId } = action.payload;
      if (!state[systemId] || !state[systemId]._initialized) {
        state[systemId] = {
          ui: uiDefaultState,
          settingsUI: settingsUIDefaultState,
          graphics: graphicsDefaultState,
          _initialized: true,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        const systems = [];
        action.payload.length > 0 &&
          action.payload.forEach((customer) => systems.push(...customer.devices));
        systems.forEach((sys) => {
          if (!state[sys.deviceId]) {
            state[sys.deviceId] = { _initialized: false };
          }
        });
      })
      .addMatcher(isUIAction, (state, action) => {
        const systemId = action.payload?.systemId || action.meta?.arg?.systemId;
        if (systemId && state[systemId]?._initialized) {
          state[systemId].ui = uiReducer(state[systemId].ui, action);
          state[systemId].settingsUI = settingsUIReducer(state[systemId].settingsUI, action);
          state[systemId].graphics = graphicsReducer(state[systemId].graphics, action);
        }
      });
  },
});

export const { initializeDeviceUI } = uiTierSlice.actions;
export default uiTierSlice.reducer;
